import{a as c,b as a}from"./chunk-3DHA63I3.js";import{a as o,m as r}from"./chunk-HBP5N4FR.js";r();a();var s=t=>t.batchTransactions,S=c(s,t=>{let e=o({},t);return delete e._persist,e});export{s as a,S as b};
//# sourceMappingURL=chunk-NNXE7L5C.js.map
